import get from "lodash/get";
import set from "lodash/set";

/**
 * Set object metadata
 *
 * @param target
 * @param key
 * @param value
 */
export function setMetadata<T>(target: Function, key: string, value: T) {
  set(target, key, value);
}

/**
 * Get object metadata
 *
 * @param target
 * @param key
 * @param value
 * @returns
 */
export function getMetadata<T>(
  target: Function,
  key: string,
  value?: T
): T | undefined {
  return get(target, key, value);
}
